export const customerTypes = [
  { id: 'Residential', name: 'Residential' },
  { id: 'Commercial', name: 'Commercial' },
  { id: 'Small Business', name: 'Small Business' },
  { id: 'Low Income', name: 'Low Income' }
]